export default __webpack_public_path__ + "static/media/play.c778b330.png";